import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../api/authService';
import '../components/Auth/Auth.css';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [resetCode, setResetCode] = useState(searchParams.get('code') || '');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const codeFromUrl = searchParams.get('code');
    const emailFromUrl = searchParams.get('email');
    if (codeFromUrl) setResetCode(codeFromUrl);
    if (emailFromUrl) setEmail(emailFromUrl);
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setFieldErrors({});
    setLoading(true);

    try {
      await authService.resetPassword(email, resetCode, password, passwordConfirmation);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      const errors = err.response?.data?.errors;
      if (errors) {
        setFieldErrors(errors);
        // Show the first relevant error as the main error
        const firstError = errors.reset_code?.[0] || errors.email?.[0] || errors.password?.[0];
        if (firstError) setError(firstError);
      } else {
        setError(err.response?.data?.message || 'Une erreur est survenue. Veuillez réessayer.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Tech360</h1>
            <p>Mot de passe réinitialisé</p>
          </div>
          <div
            style={{
              background: '#f0fff4',
              color: '#276749',
              padding: '14px',
              borderRadius: '6px',
              fontSize: '14px',
              border: '1px solid #9ae6b4',
              textAlign: 'center',
              lineHeight: '1.6',
            }}
          >
            Votre mot de passe a été réinitialisé avec succès.
            <br />
            Redirection vers la connexion...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Tech360</h1>
          <p>Nouveau mot de passe</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="email">Adresse email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@tech360.com"
              disabled={loading}
            />
            {fieldErrors.email && (
              <span style={{ color: '#c53030', fontSize: '12px' }}>{fieldErrors.email[0]}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="reset_code">Code de réinitialisation</label>
            <input
              type="text"
              id="reset_code"
              value={resetCode}
              onChange={(e) => setResetCode(e.target.value)}
              required
              placeholder="123456"
              maxLength={6}
              disabled={loading}
              style={{ letterSpacing: '0.2em', fontFamily: 'monospace', fontSize: '18px' }}
            />
            {fieldErrors.reset_code && (
              <span style={{ color: '#c53030', fontSize: '12px' }}>{fieldErrors.reset_code[0]}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="password">Nouveau mot de passe</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Minimum 8 caractères"
              minLength={8}
              disabled={loading}
            />
            {fieldErrors.password && (
              <span style={{ color: '#c53030', fontSize: '12px' }}>{fieldErrors.password[0]}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="password_confirmation">Confirmer le mot de passe</label>
            <input
              type="password"
              id="password_confirmation"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              required
              placeholder="Répétez votre mot de passe"
              minLength={8}
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
          </button>

          <div style={{ textAlign: 'center' }}>
            <Link to="/forgot-password" style={{ color: '#718096', fontSize: '14px', textDecoration: 'none' }}>
              ← Renvoyer le code
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
